
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#009AF6"}},[_c('path',{attrs:{"d":"M11.998 18.794a.992.992 0 01-.707-.295L5 12.208c-.355-.355-.252-.698-.212-.795.041-.097.211-.413.712-.413H8V1.5C8 .673 8.673 0 9.5 0h5c.827 0 1.5.673 1.5 1.5v9.503l2.524.014c.506.004.673.324.713.422.039.098.138.444-.223.793l-6.306 6.27a.995.995 0 01-.707.293h-.003zm.005-1.002l5.812-5.779L15.497 12a.5.5 0 01-.497-.5v-10a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5V11c0 .551-.449 1-1 1H6.207l5.79 5.791h.001a.01.01 0 01.005.001z"}}),_c('path',{attrs:{"d":"M1.5 24C.673 24 0 23.327 0 22.5v-4a.5.5 0 011 0v4a.5.5 0 00.5.5h21a.5.5 0 00.5-.5v-4a.5.5 0 011 0v4c0 .827-.673 1.5-1.5 1.5h-21z"}})])])
          )
        }
      }
    